// Group consecutive description items and wrap them in expandable container
document.addEventListener('DOMContentLoaded', () => {
  // Find all .ua-description-item elements
  const descriptionItems = document.querySelectorAll('.ua-description-item');

  if (descriptionItems.length === 0) return;

  // Group consecutive description items
  const groups = [];
  let currentGroup = [];
  let lastParent = null;

  descriptionItems.forEach((item, index) => {
    const parent = item.parentElement;

    // Check if this item is consecutive with the previous one
    if (lastParent && parent === lastParent &&
        (currentGroup.length === 0 ||
         currentGroup[currentGroup.length - 1].nextElementSibling === item ||
         currentGroup[currentGroup.length - 1].nextSibling === item.previousSibling)) {
      currentGroup.push(item);
    } else {
      if (currentGroup.length > 0) {
        groups.push([...currentGroup]);
      }
      currentGroup = [item];
    }

    lastParent = parent;

    // Push the last group
    if (index === descriptionItems.length - 1 && currentGroup.length > 0) {
      groups.push(currentGroup);
    }
  });

  // Wrap each group in an expandable container
  groups.forEach(group => {
    if (group.length === 0) return;

    const firstItem = group[0];
    const parent = firstItem.parentElement;

    // Create wrapper container
    const wrapper = document.createElement('div');
    wrapper.className = 'ua-description-container';
    wrapper.setAttribute('data-expandable', '');

    // Create content container
    const content = document.createElement('div');
    content.className = 'ua-description-content';

    // Create toggle button
    const toggleBtn = document.createElement('button');
    toggleBtn.type = 'button';
    toggleBtn.className = 'ua-description-toggle';
    toggleBtn.setAttribute('aria-expanded', 'false');

    const moreSpan = document.createElement('span');
    moreSpan.className = 'ua-description-toggle__more';
    moreSpan.textContent = toggleBtn.getAttribute('data-more-text') || 'Show more';

    const lessSpan = document.createElement('span');
    lessSpan.className = 'ua-description-toggle__less';
    lessSpan.textContent = toggleBtn.getAttribute('data-less-text') || 'Show less';

    toggleBtn.appendChild(moreSpan);
    toggleBtn.appendChild(lessSpan);

    // Insert wrapper before first item
    parent.insertBefore(wrapper, firstItem);

    // Move all items into content container
    group.forEach(item => {
      content.appendChild(item);
    });

    // Assemble the structure
    wrapper.appendChild(content);
    wrapper.appendChild(toggleBtn);

    // Initialize expandable behavior
    initExpandable(wrapper, content, toggleBtn);
  });

  // Get translation text for buttons
  const productContainer = document.querySelector('.product--section');
  if (productContainer) {
    const moreText = productContainer.getAttribute('data-more-text') || 'Show more';
    const lessText = productContainer.getAttribute('data-less-text') || 'Show less';

    document.querySelectorAll('.ua-description-toggle__more').forEach(el => {
      if (!el.textContent || el.textContent === 'Show more') {
        el.textContent = moreText;
      }
    });

    document.querySelectorAll('.ua-description-toggle__less').forEach(el => {
      if (!el.textContent || el.textContent === 'Show less') {
        el.textContent = lessText;
      }
    });
  }
});

function initExpandable(container, content, toggleBtn) {
  // Check if content needs expansion
  const checkHeight = () => {
    const contentHeight = content.scrollHeight;
    const lineHeight = parseFloat(getComputedStyle(content).lineHeight) || 24;
    const maxHeight = lineHeight * 4;

    if (contentHeight > maxHeight) {
      container.classList.add('needs-toggle');
    } else {
      container.classList.remove('needs-toggle');
      container.classList.remove('is-expanded');
    }
  };

  checkHeight();

  // Recheck on window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(checkHeight, 100);
  });

  // Add click handler
  toggleBtn.addEventListener('click', () => {
    const isExpanding = !container.classList.contains('is-expanded');

    if (isExpanding) {
      // Set max-height to actual content height for smooth animation
      const contentHeight = content.scrollHeight;
      content.style.maxHeight = contentHeight + 'px';
    } else {
      // Collapse: first set to scrollHeight, then to collapsed height
      const contentHeight = content.scrollHeight;
      content.style.maxHeight = contentHeight + 'px';

      // Force reflow
      content.offsetHeight;

      // Then collapse
      const lineHeight = parseFloat(getComputedStyle(content).lineHeight) || 24;
      content.style.maxHeight = (lineHeight * 4) + 'px';
    }

    container.classList.toggle('is-expanded');
    toggleBtn.setAttribute(
      'aria-expanded',
      container.classList.contains('is-expanded') ? 'true' : 'false'
    );

    // Clear inline max-height after animation completes
    setTimeout(() => {
      if (container.classList.contains('is-expanded')) {
        content.style.maxHeight = '';
      }
    }, 500);
  });
}
